/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
export interface ApiResponse {
  readonly msg: string;
  readonly type: string;
  readonly self: string;
  readonly props: Array<object>;
  readonly data: any;
  readonly meta: any;
}

/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
export class ApiResponse {
  public static createMockResponseObject(dataIn: any, success = true): Promise<ApiResponse> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (success) {
          resolve({
            data: dataIn,
          } as ApiResponse);
        } else {
          reject('Mock API Error');
        }
      }, 500);
    });
  }
}
